
import Layout from "../../components/feature/Layout";
import { useState } from "react";

export default function Users() {
  const [showNewUserModal, setShowNewUserModal] = useState(false);
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const [showRoleModal, setShowRoleModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [selectedRole, setSelectedRole] = useState<any>(null);

  const showToast = (message: string) => {
    setToastMessage(message);
    setShowSuccessToast(true);
    setTimeout(() => setShowSuccessToast(false), 3000);
  };

  const users = [
    { id: 1, name: "María González", email: "maria.gonzalez@cominter.com", role: "Ejecutivo Comercial", status: "Activo", lastLogin: "2024-01-16 09:30", avatar: "MG" },
    { id: 2, name: "Carlos Ruiz", email: "carlos.ruiz@cominter.com", role: "Ejecutivo Comercial", status: "Activo", lastLogin: "2024-01-16 08:15", avatar: "CR" },
    { id: 3, name: "Ana Martínez", email: "ana.martinez@cominter.com", role: "Ejecutivo Comercial", status: "Activo", lastLogin: "2024-01-15 17:45", avatar: "AM" },
    { id: 4, name: "Roberto Sánchez", email: "roberto.sanchez@cominter.com", role: "Gerente Operaciones", status: "Activo", lastLogin: "2024-01-16 10:00", avatar: "RS" },
    { id: 5, name: "Laura Fernández", email: "laura.fernandez@cominter.com", role: "Contador", status: "Activo", lastLogin: "2024-01-16 07:30", avatar: "LF" },
    { id: 6, name: "Jorge Ramírez", email: "jorge.ramirez@cominter.com", role: "Administrador", status: "Activo", lastLogin: "2024-01-16 09:00", avatar: "JR" },
    { id: 7, name: "Patricia López", email: "patricia.lopez@cominter.com", role: "Analista", status: "Inactivo", lastLogin: "2024-01-10 16:20", avatar: "PL" },
  ];

  const roles = [
    { id: 1, name: "Administrador", users: 2, permissions: ["Dashboard", "Operaciones", "CRM", "ERP", "Reportes", "Usuarios", "Configuración"], color: "bg-[#EF4444]" },
    { id: 2, name: "Gerente Operaciones", users: 3, permissions: ["Dashboard", "Operaciones", "CRM", "Reportes"], color: "bg-[#2F80ED]" },
    { id: 3, name: "Ejecutivo Comercial", users: 8, permissions: ["Dashboard", "Operaciones (lectura)", "CRM"], color: "bg-[#10B981]" },
    { id: 4, name: "Contador", users: 2, permissions: ["Dashboard", "ERP Financiero", "Reportes"], color: "bg-[#EAB308]" },
    { id: 5, name: "Analista", users: 4, permissions: ["Dashboard", "Reportes"], color: "bg-[#6B7280]" },
  ];

  const modules = [
    { id: "dashboard", name: "Dashboard", icon: "ri-dashboard-line" },
    { id: "operations", name: "Operaciones", icon: "ri-ship-line" },
    { id: "crm", name: "CRM", icon: "ri-user-star-line" },
    { id: "portal", name: "Portal Clientes", icon: "ri-global-line" },
    { id: "erp", name: "ERP Financiero", icon: "ri-money-dollar-circle-line" },
    { id: "reports", name: "Reportes", icon: "ri-bar-chart-box-line" },
    { id: "users", name: "Usuarios", icon: "ri-team-line" },
    { id: "settings", name: "Configuración", icon: "ri-settings-3-line" },
  ];

  const handleCreateUser = () => {
    setShowNewUserModal(false);
    showToast('Usuario creado exitosamente');
  };

  const handleEditUser = (user: any) => {
    setSelectedUser(user);
    setShowEditUserModal(true);
  };

  const handleDeleteUser = (user: any) => {
    setSelectedUser(user);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    setShowDeleteModal(false);
    showToast('Usuario eliminado exitosamente');
  };

  const handleEditRole = (role: any) => {
    setSelectedRole(role);
    setShowRoleModal(true);
  };

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#0A2A43]">Usuarios y Permisos</h1>
            <p className="text-sm text-gray-500 mt-1">Gestión de usuarios, roles y permisos</p>
          </div>
          <button 
            onClick={() => setShowNewUserModal(true)}
            className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:opacity-90 transition-opacity whitespace-nowrap flex items-center gap-2 cursor-pointer"
          >
            <i className="ri-user-add-line"></i>
            Nuevo Usuario
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Usuarios Totales</p>
                <p className="text-2xl font-bold text-[#0A2A43]">21</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-user-line text-2xl text-[#2F80ED]"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Usuarios Activos</p>
                <p className="text-2xl font-bold text-[#0A2A43]">19</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-user-follow-line text-2xl text-[#10B981]"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Roles Definidos</p>
                <p className="text-2xl font-bold text-[#0A2A43]">5</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-shield-user-line text-2xl text-[#114B7A]"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Sesiones Activas</p>
                <p className="text-2xl font-bold text-[#0A2A43]">14</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-login-circle-line text-2xl text-[#EAB308]"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] overflow-hidden">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-lg font-bold text-[#0A2A43]">Usuarios</h2>
              <div className="relative">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
                <input type="text" placeholder="Buscar usuario..." className="pl-10 pr-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-[#EAF2F8]">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Usuario</th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Rol</th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Estado</th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Último Acceso</th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Acciones</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {users.map((user) => (
                    <tr key={user.id} className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#114B7A] to-[#2F80ED] flex items-center justify-center text-white font-semibold text-sm">
                            {user.avatar}
                          </div>
                          <div>
                            <p className="text-sm font-semibold text-[#0A2A43]">{user.name}</p>
                            <p className="text-xs text-gray-500">{user.email}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-600">{user.role}</td>
                      <td className="px-6 py-4">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                          user.status === "Activo" ? "bg-[#10B981]/10 text-[#10B981]" : "bg-gray-100 text-gray-600"
                        }`}>
                          <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${user.status === "Activo" ? "bg-[#10B981]" : "bg-gray-400"}`}></span>
                          {user.status}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-600">{user.lastLogin}</td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2">
                          <button 
                            onClick={() => handleEditUser(user)}
                            className="w-8 h-8 flex items-center justify-center text-[#2F80ED] hover:bg-[#EAF2F8] rounded-md transition-colors cursor-pointer"
                          >
                            <i className="ri-edit-line"></i>
                          </button>
                          <button 
                            onClick={() => handleDeleteUser(user)}
                            className="w-8 h-8 flex items-center justify-center text-[#EF4444] hover:bg-red-50 rounded-md transition-colors cursor-pointer"
                          >
                            <i className="ri-delete-bin-line"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-bold text-[#0A2A43]">Roles y Permisos</h2>
              <button className="w-8 h-8 flex items-center justify-center text-[#2F80ED] hover:bg-[#EAF2F8] rounded-md transition-colors cursor-pointer">
                <i className="ri-add-line"></i>
              </button>
            </div>
            <div className="space-y-3">
              {roles.map((role) => (
                <div 
                  key={role.id} 
                  onClick={() => handleEditRole(role)}
                  className="p-4 border border-gray-200 rounded-lg hover:border-[#2F80ED] transition-colors cursor-pointer"
                >
                  <div className="flex items-start justify-between mb-2">
                    <div className="flex items-center gap-2">
                      <span className={`w-3 h-3 rounded-full ${role.color}`}></span>
                      <h3 className="text-sm font-semibold text-[#0A2A43]">{role.name}</h3>
                    </div>
                    <span className="px-2 py-0.5 bg-[#EAF2F8] text-[#2F80ED] text-xs font-medium rounded-full whitespace-nowrap">
                      {role.users} usuarios
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-1">
                    {role.permissions.slice(0, 3).map((perm, i) => (
                      <span key={i} className="px-2 py-0.5 bg-gray-100 text-gray-600 text-xs rounded">
                        {perm}
                      </span>
                    ))}
                    {role.permissions.length > 3 && (
                      <span className="px-2 py-0.5 bg-gray-100 text-gray-600 text-xs rounded">
                        +{role.permissions.length - 3}
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <button className="w-full mt-4 px-4 py-2 border border-[#2F80ED] text-[#2F80ED] rounded-md hover:bg-[#EAF2F8] transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-add-line mr-2"></i>Crear Nuevo Rol
            </button>
          </div>
        </div>
      </div>

      {/* Modal Nuevo Usuario */}
      {showNewUserModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-lg mx-4">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-xl font-bold text-[#0A2A43]">Nuevo Usuario</h2>
              <button onClick={() => setShowNewUserModal(false)} className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-xl text-[#6B7280]"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nombre *</label>
                  <input type="text" placeholder="Nombre completo" className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
                  <input type="email" placeholder="correo@cominter.com" className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Rol *</label>
                <select className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                  <option>Seleccionar rol...</option>
                  {roles.map((role) => (
                    <option key={role.id}>{role.name}</option>
                  ))}
                </select>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Contraseña *</label>
                  <input type="password" placeholder="••••••••" className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Confirmar Contraseña *</label>
                  <input type="password" placeholder="••••••••" className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
              </div>
              <div className="flex items-center gap-2">
                <input type="checkbox" id="sendEmail" defaultChecked className="rounded border-gray-300" />
                <label htmlFor="sendEmail" className="text-sm text-gray-700">Enviar credenciales por email</label>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end gap-3">
              <button onClick={() => setShowNewUserModal(false)} className="px-4 py-2 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                Cancelar
              </button>
              <button onClick={handleCreateUser} className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap">
                Crear Usuario
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Editar Usuario */}
      {showEditUserModal && selectedUser && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-lg mx-4">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-xl font-bold text-[#0A2A43]">Editar Usuario</h2>
              <button onClick={() => setShowEditUserModal(false)} className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-xl text-[#6B7280]"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#114B7A] to-[#2F80ED] flex items-center justify-center text-white font-bold text-xl">
                  {selectedUser.avatar}
                </div>
                <div>
                  <p className="text-lg font-semibold text-[#0A2A43]">{selectedUser.name}</p>
                  <p className="text-sm text-gray-500">{selectedUser.email}</p>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nombre</label>
                <input type="text" defaultValue={selectedUser.name} className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                <input type="email" defaultValue={selectedUser.email} className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Rol</label>
                <select defaultValue={selectedUser.role} className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                  {roles.map((role) => (
                    <option key={role.id}>{role.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Estado</label>
                <select defaultValue={selectedUser.status} className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                  <option>Activo</option>
                  <option>Inactivo</option>
                </select>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-between">
              <button className="px-4 py-2 text-[#2F80ED] hover:bg-[#EAF2F8] rounded-md cursor-pointer whitespace-nowrap">
                Restablecer Contraseña
              </button>
              <div className="flex gap-3">
                <button onClick={() => setShowEditUserModal(false)} className="px-4 py-2 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                  Cancelar
                </button>
                <button 
                  onClick={() => {
                    setShowEditUserModal(false);
                    showToast('Usuario actualizado exitosamente');
                  }}
                  className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap"
                >
                  Guardar Cambios
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Editar Rol */}
      {showRoleModal && selectedRole && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-xl font-bold text-[#0A2A43]">Editar Rol: {selectedRole.name}</h2>
              <button onClick={() => setShowRoleModal(false)} className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-xl text-[#6B7280]"></i>
              </button>
            </div>
            <div className="p-6 space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nombre del Rol</label>
                <input type="text" defaultValue={selectedRole.name} className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-4">Permisos por Módulo</label>
                <div className="space-y-3">
                  {modules.map((module) => (
                    <div key={module.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                      <div className="flex items-center gap-3">
                        <i className={`${module.icon} text-xl text-[#2F80ED]`}></i>
                        <span className="text-sm font-medium text-[#0A2A43]">{module.name}</span>
                      </div>
                      <div className="flex items-center gap-4">
                        <label className="flex items-center gap-2 cursor-pointer">
                          <input type="checkbox" defaultChecked={selectedRole.permissions.includes(module.name)} className="rounded border-gray-300" />
                          <span className="text-xs text-gray-600">Ver</span>
                        </label>
                        <label className="flex items-center gap-2 cursor-pointer">
                          <input type="checkbox" defaultChecked={selectedRole.name === 'Administrador'} className="rounded border-gray-300" />
                          <span className="text-xs text-gray-600">Editar</span>
                        </label>
                        <label className="flex items-center gap-2 cursor-pointer">
                          <input type="checkbox" defaultChecked={selectedRole.name === 'Administrador'} className="rounded border-gray-300" />
                          <span className="text-xs text-gray-600">Eliminar</span>
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end gap-3">
              <button onClick={() => setShowRoleModal(false)} className="px-4 py-2 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                Cancelar
              </button>
              <button 
                onClick={() => {
                  setShowRoleModal(false);
                  showToast('Rol actualizado exitosamente');
                }}
                className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap"
              >
                Guardar Cambios
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Confirmar Eliminación */}
      {showDeleteModal && selectedUser && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-md mx-4">
            <div className="p-6">
              <div className="w-16 h-16 rounded-full bg-[#EF4444]/10 flex items-center justify-center mx-auto mb-4">
                <i className="ri-delete-bin-line text-3xl text-[#EF4444]"></i>
              </div>
              <h2 className="text-xl font-bold text-[#0A2A43] text-center mb-2">¿Eliminar Usuario?</h2>
              <p className="text-sm text-gray-500 text-center mb-6">
                ¿Estás seguro de que deseas eliminar a <strong>{selectedUser.name}</strong>? Esta acción no se puede deshacer.
              </p>
              <div className="flex gap-3">
                <button onClick={() => setShowDeleteModal(false)} className="flex-1 px-4 py-2 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                  Cancelar
                </button>
                <button onClick={confirmDelete} className="flex-1 px-4 py-2 bg-[#EF4444] text-white rounded-md hover:bg-[#DC2626] cursor-pointer whitespace-nowrap">
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Toast */}
      {showSuccessToast && (
        <div className="fixed bottom-6 right-6 bg-[#10B981] text-white px-6 py-4 rounded-lg shadow-lg flex items-center gap-3 z-50">
          <i className="ri-check-circle-line text-xl"></i>
          <span className="font-medium">{toastMessage}</span>
        </div>
      )}
    </Layout>
  );
}
